module.exports = __webpack_public_path__ + "img/Integral Ad Science.740ab00b.png";